module.exports = __webpack_public_path__ + "static/kuhne-sm-7e1ff7292d48b972db54f8b7af65ec91.jpg";